"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sliceKey = exports.reducer = exports.guestBasketProviderActions = exports.initialState = void 0;
const toolkit_1 = require("../../utils/@reduxjs/toolkit");
const REDUCER_KEY = 'guestBasketProvider';
exports.initialState = {
    guestBasket: {
        entries: {},
        sortedIds: [],
    },
};
const guestBasketStateSlice = (0, toolkit_1.createSlice)({
    name: REDUCER_KEY,
    initialState: exports.initialState,
    reducers: {
        addToGuestBasket(state, action) { },
        checkGuestBasketEvents() { },
        rehydrate() { },
        restore(state, { payload }) {
            state.guestBasket = payload.guestBasket;
        },
        addGuestBasketItem(state, { payload }) {
            state.guestBasket.entries[payload.id] = payload;
            state.guestBasket.sortedIds.push(payload.id);
        },
        deleteGuestBasketItem(state, { payload }) {
            delete state.guestBasket.entries[payload.outcomeKey];
            state.guestBasket.sortedIds = state.guestBasket.sortedIds.filter((el) => el !== payload.outcomeKey);
        },
        clearGuestBasket(state) {
            state.guestBasket.entries = {};
            state.guestBasket.sortedIds = [];
        },
        updateGuestBasketItems(state, { payload }) {
            state.guestBasket.entries = {
                ...state.guestBasket.entries,
                ...payload,
            };
        },
    },
});
exports.guestBasketProviderActions = guestBasketStateSlice.actions, exports.reducer = guestBasketStateSlice.reducer, exports.sliceKey = guestBasketStateSlice.name;
//# sourceMappingURL=slice.js.map